import { FlagDefinitions, flagg } from "flagg/dist/core";
import { inMemoryStore } from "flagg/dist/store";

import { Maybe, ValueOf } from "types";

export const FeatureFlag = {
  BUILD_20: "build_20",
  EMBEDDED_SIGNUP_V2: "embedded_signup_v2",
  HANDOVER: "handover",
  INBOX: "inbox",
  APPS: "apps",
  LIVEBOX: "livebox",
  LLM: "llm",
  MFA: "mfa",
  OPERATOR_METRICS: "operator_metrics",
  TRIGGER: "trigger",
  VARIABLES: "variables",
  RIPPLE: "experimental_ripple",
  CANVAS_VIEW_SOURCE: "canvas_view_source",
  CALLING: "calling",
  AI_TRACING: "ai_tracing",
  POSTHOG_PRODUCT_ANALYTICS: "posthog_product_analytics",
  RESTRICTED_OPERATOR: "restricted_operator_2408",
  AI_MEMORY: "ai_memory",
  WAITING_FOR_HELP_CHATS: "waiting_for_help_chats",
  CATALOG_CARD: "catalog_card",
  CONVERSION_CARD: "conversion_card",
  AUTO_JOURNEY_PAUSING: "auto_journey_pausing",
  WHATSAPP_FLOW_CARD: "whatsapp_flow_card",
  AI_AGENT_COLLECT_DATA: "ai_agent_collect_data",
} as const;

export type TFeatureFlag = ValueOf<typeof FeatureFlag>;

let currentFeatureFlags: ReturnType<typeof flagg>;

const createFeatureFlags = (): ReturnType<typeof flagg> => {
  return flagg({
    store: inMemoryStore(),
    definitions: Object.values(FeatureFlag).reduce((definitions: FlagDefinitions, feature) => {
      definitions[feature] = { default: false };
      return definitions;
    }, {}),
  });
};

currentFeatureFlags = createFeatureFlags();

export const getFeatureFlags = () => currentFeatureFlags;

export const resetFeatureFlags = () => {
  currentFeatureFlags = createFeatureFlags();
};

export const initFeatureFlags = (enabledFeatures: Maybe<(string | null)[]>) => {
  const featureFlags = getFeatureFlags();

  (enabledFeatures ?? []).forEach((feature) => {
    if (feature) {
      featureFlags.set(feature, true);
    }
  });

  featureFlags.freezeAll();
};

export const isEnabledFeature = (feature: TFeatureFlag) => !!getFeatureFlags().get(feature);
